import { render, staticRenderFns } from "./PlatformProfit.vue?vue&type=template&id=41a5c0f9&scoped=true"
import script from "./PlatformProfit.vue?vue&type=script&lang=js"
export * from "./PlatformProfit.vue?vue&type=script&lang=js"
import style0 from "./PlatformProfit.vue?vue&type=style&index=0&id=41a5c0f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a5c0f9",
  null
  
)

export default component.exports